"use client";

import { useEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getLenisInstance, isScrolling } from "@/lib/lenis-instance";

// Multiple sections on the same page can resolve their async content (React Query fetches, lazy
// mounts) within a few frames of each other. Without this, each one calling ScrollTrigger.refresh()
// independently causes redundant recalculation passes; debouncing collapses them into one.
let pending: ReturnType<typeof setTimeout> | null = null;
const DEBOUNCE_MS = 80;

function doRefresh() {
  // Never refresh mid-scroll — recalculating trigger positions during a gesture tugs the scroll
  // position backwards (reads as a freeze near the bottom). Retry shortly until scroll goes idle.
  if (isScrolling()) {
    pending = setTimeout(doRefresh, 150);
    return;
  }
  pending = null;
  getLenisInstance()?.resize();
  ScrollTrigger.refresh();
}

function scheduleRefresh() {
  if (pending) clearTimeout(pending);
  pending = setTimeout(doRefresh, DEBOUNCE_MS);
}

export function useScrollTriggerRefresh(deps: React.DependencyList) {
  useEffect(() => {
    scheduleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
